import { writable } from 'svelte/store';

export const showParaModal = writable(false);

// Helper function to show login modal (now just opens the modal)
export const showLoginModal = () => {
	showParaModal.set(true);
};

// Helper function to show wallet modal (now just opens the modal)
export const showWalletModal = () => {
	showParaModal.set(true);
};

// Helper function to close modal
export const closeParaModal = () => {
	showParaModal.set(false);
};
